import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { useComparisonTableDropdownIndices } from '../utils';

interface ProductType {
  productPrice?: RichTextFieldStrapiProps;
  productButton?: LinkButtonStrapiProps;
}

interface SelectedDataItem {
  productType?: ProductType;
}

interface PriceActionRowProps {
  selectedData?: SelectedDataItem[];
  headerHeights?: (number | undefined)[];
  stickyOffsetTop?: number;
}

export const PriceAndButtonComparison = ({
  product,
}: {
  product: ProductType | undefined;
}) => (
  <>
    <div className='text-body-m py-2'>
      {product?.productPrice && (
        <RichTextFieldStrapi block={{ ...product.productPrice }} />
      )}
    </div>
    <div className='min-h-[48px]'>
      {product?.productButton && (
        <LinkButtonStrapi
          block={product.productButton}
          inner={{ classNames: { root: 'w-full' } }}
        />
      )}
    </div>
  </>
);

export const PriceActionRow = ({
  selectedData,
  headerHeights,
  stickyOffsetTop,
}: PriceActionRowProps) => {
  const visibleItemsCount = selectedData?.filter(Boolean).length ?? 0;

  const dropdownIndices = useComparisonTableDropdownIndices();
  return (
    <div className='bg-gray-25 grid grid-cols-[160px_repeat(3,_minmax(200px,_1fr))] pb-6'>
      {/* Empty placeholder column */}
      <div />

      {dropdownIndices.map((i) => {
        const product = selectedData?.[i]?.productType;

        if (i > visibleItemsCount) return null;

        if (visibleItemsCount === i) {
          return (
            <div
              key={`footer-${i}`}
              className='bg-gray-25 text-body-m flex items-center py-2 pl-12 font-serif'
              style={{
                position: 'sticky',
                top: (stickyOffsetTop ?? 0) + (headerHeights?.[i] ?? 0),
              }}
            >
              -
            </div>
          );
        }

        return (
          <div
            key={`footer-${i}`}
            className='bg-gray-25 text-body-m flex flex-col gap-2 py-2 pl-12'
            style={{
              position: 'sticky',
              top: (stickyOffsetTop ?? 0) + (headerHeights?.[i] ?? 0),
            }}
          >
            <PriceAndButtonComparison product={product} />
          </div>
        );
      })}
    </div>
  );
};
